"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientList = void 0;
const Base_1 = require("./Base");
exports.GetClientList = {
    url: Base_1.URL_BASE + "/GetClientsList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientList.js.map